
const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 to-slate-800 text-white py-24">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/c7153e9034fd775b88dd26a656ea1605.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            Real Results from 
            <span className="text-teal-400"> Real Businesses</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            See how we've helped small businesses break through international barriers 
            and achieve remarkable growth in global markets.
          </p>
          <div className="flex flex-wrap gap-6 text-sm">
            <div className="flex items-center">
              <i className="ri-line-chart-line text-teal-400 mr-2"></i>
              <span>400% Average Growth</span>
            </div>
            <div className="flex items-center">
              <i className="ri-global-line text-teal-400 mr-2"></i>
              <span>25+ Countries Entered</span>
            </div>
            <div className="flex items-center">
              <i className="ri-money-dollar-circle-line text-teal-400 mr-2"></i>
              <span>$50M+ Revenue Generated</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
